module.exports = __webpack_public_path__ + "img/moderation_fail_16px.5b66e6b3.svg";